import { generateRepositoryMethods, } from '../webapp/repository.types.js';
export const appRepositoryMethods = generateRepositoryMethods({
    getCustomerPortalState: {
        callMethod: 'GET',
        endpoint: '/customer-portal/state',
    },
    setCustomerPortalState: {
        callMethod: 'PUT',
        endpoint: '/customer-portal/set-state',
    },
    getApplicationState: {
        callMethod: 'GET',
        endpoint: '/application/state',
    },
    getDoctorById: {
        callMethod: 'GET',
        endpoint: '/doctor/by-id',
    },
    getAllDoctorsReceivingReport: {
        callMethod: 'GET',
        endpoint: '/doctor/all-receiving-report',
    },
    getAllDoctorsPerPage: {
        callMethod: 'GET',
        endpoint: '/doctor/all-per-page',
    },
    savePharmacyData: {
        callMethod: 'PUT',
        endpoint: '/pharmacy/save',
    },
    createPharmacy: {
        callMethod: 'POST',
        endpoint: '/pharmacy/create',
    },
    setPickPostState: {
        callMethod: 'PUT',
        endpoint: '/pickpost/set-state',
    },
    queryPickPostsService: {
        callMethod: 'GET',
        endpoint: '/pickpost/query',
    },
    uploadPickPostFile: {
        callMethod: 'POST',
        endpoint: '/pickpost/import',
    },
    exportPickPosts: {
        callMethod: 'GET',
        endpoint: '/pickpost/export',
    },
    getServiceProperty: {
        callMethod: 'GET',
        endpoint: '/service-property/get-key',
    },
    generateImpersonationUrl: {
        callMethod: 'GET',
        endpoint: '/impersonation-url/generate',
    },
    generateOauth2Redirect: {
        callMethod: 'POST',
        endpoint: '/auth/redirect',
    },
    getEmployeeInformation: {
        callMethod: 'GET',
        endpoint: '/employee/information',
    },
    updateDoctor: {
        callMethod: 'PUT',
        endpoint: '/doctor/update',
    },
    getPharmacyById: {
        callMethod: 'GET',
        endpoint: '/pharmacy/by-id',
    },
    getAllPharmaciesPaginated: {
        callMethod: 'GET',
        endpoint: '/pharmacy/all-paginated',
    },
    cookieLogin: {
        callMethod: 'POST',
        endpoint: '/auth/cookie/login',
    },
    reflectCookie: {
        callMethod: 'GET',
        endpoint: '/auth/reflect-cookie',
    },
    refreshCookie: {
        callMethod: 'POST',
        endpoint: '/auth/refresh-cookie',
    },
    revokeCookie: {
        callMethod: 'DELETE',
        endpoint: '/auth/refresh-cookie/revoke',
    },
});
//# sourceMappingURL=app.methods.js.map